import React, { useEffect, useRef } from "react";

function useOutsideAlerter(ref, onOutsideClick, activeCondition) {
  useEffect(() => {
    // Function to handle clicks outside of the element
    function handleClickOutside(event) {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        activeCondition
      ) {
        onOutsideClick();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, onOutsideClick, activeCondition]);
}

// Component that detects clicks outside of it and calls a callback function
export default function OutsideAlerter(props) {
  const wrapperRef = useRef(null);

  const { onOutsideClick, activeCondition = true } = props;
  useOutsideAlerter(wrapperRef, onOutsideClick, activeCondition);

  // Clone the child component and add the forwarded ref
  const childWithRef = React.cloneElement(props.children, { ref: wrapperRef });

  return <>{childWithRef}</>;
}
